import { Brick, registerBrick } from 'olympe';

export default class SetDataInSessionStorage extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} key
     * @param {string} value
     * @param {function()} forwardEvent
     */
    update($, [key, value], [forwardEvent]) {
        console.log("::::key, value::::", key, value)
         sessionStorage.setItem(key, value)
        forwardEvent();
    }
}

registerBrick('019eda3d6a9382d87c80', SetDataInSessionStorage);
